import { useEffect, useRef } from "react";

const STATS = [
  { target: 25000, suffix: "+", decimals: 0, label: "Readings Given" },
  { target: 12, suffix: "", decimals: 0, label: "Years of Practice" },
  { target: 4.9, suffix: "", decimals: 1, label: "Average Rating" },
  { target: 40, suffix: "+", decimals: 0, label: "Countries Reached" },
];

export const Stats = () => {
  const sectionRef = useRef(null);
  const numberRefs = useRef([]);

  useEffect(() => {
    if (!window.gsap || !window.ScrollTrigger || !sectionRef.current) return;
    const gsapLib = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsapLib.registerPlugin(ScrollTrigger);

    gsapLib.fromTo(
      numberRefs.current.map((el) => el && el.closest("[data-testid]")).filter(Boolean),
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: { trigger: sectionRef.current, start: "top 85%" },
      }
    );

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top 85%",
      once: true,
      onEnter: () => {
        STATS.forEach((s, i) => {
          const el = numberRefs.current[i];
          if (!el) return;
          const counter = { val: 0 };
          gsapLib.to(counter, {
            val: s.target,
            duration: 1.8,
            ease: "power1.out",
            onUpdate: () => {
              const v = s.decimals ? counter.val.toFixed(s.decimals) : Math.round(counter.val).toLocaleString();
              el.textContent = `${v}${s.suffix}`;
            },
          });
        });
      },
    });
  }, []);

  return (
    <section id="stats" ref={sectionRef} className="cosmic-section max-w-6xl mx-auto">
      <div className="divider-glow mb-16" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
        {STATS.map((s, i) => (
          <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <p
              ref={(el) => (numberRefs.current[i] = el)}
              className="font-display text-3xl md:text-5xl gold-gradient-text mb-2"
            >
              0{s.suffix}
            </p>
            <p className="text-sm uppercase tracking-[0.15em] text-[#A99BFF]">{s.label}</p>
          </div>
        ))}
      </div>
      <div className="divider-glow mt-16" />
    </section>
  );
};
